// extracted by mini-css-extract-plugin
export default {"ServantInfo":"ServantInfo_ServantInfo__UIWFX","shad":"ServantInfo_shad__Xdruh"};